import { useEffect, useState } from "react";
import usePosOrders from "../../../services/Pos/usePosOrders";
import { toast } from "react-toastify";

export default function EditCustomerModal({
  open,
  onClose,
  onCloseAll,
  order,
  onSave,
}) {
  const [customerName, setCustomerName] = useState("");
  const [billingName, setBillingName] = useState("");
  const [billingGst, setBillingGst] = useState("");
  const [billingAddress, setBillingAddress] = useState("");

  const { updateCustomerDetails } = usePosOrders();

  useEffect(() => {
    if (open) {
      setCustomerName(order?.customer_name || order?.customer_mobile || "");
      setBillingName(order?.billing_name || "");
      setBillingGst(order?.billing_gst || "");
      setBillingAddress(order?.billing_address || "");
    }
  }, [open, order]);

  if (!open) return null;

 const handleSave = async () => {
  if (!order?.orderid) {
    toast.error("Invalid Order");
    return;
  }

  const cleanMobile = String(order?.customer_mobile || "")
    .replace("+91", "")
    .replace(/\D/g, "");

  const formattedMobile = cleanMobile ? `+91 ${cleanMobile}` : "";

  const payload = {
    orderId: order.orderid,
    custName: String(customerName || "").trim(),
    custMobile: formattedMobile,
    billingName: String(billingName || "").trim(),
    billingGst: String(billingGst || "").trim(),
    address: String(billingAddress || "").trim(),
  };

  try {
    const success = await updateCustomerDetails(payload);

    if (success) {
      const updatedCustomerData = {
        customer_name: payload.custName,
        customer_mobile: payload.custMobile,
        billing_name: payload.billingName,
        billing_gst: payload.billingGst,
        billing_address: payload.address,

        // these are for current modal display fallback
        customerName: payload.custName,
        billingName: payload.billingName,
        billingGst: payload.billingGst,
        billingAddress: payload.address,
      };

      onSave?.(updatedCustomerData);

      toast.success("Customer updated successfully");
      window.dispatchEvent(new Event("order-updated"));

      onClose();
      onCloseAll?.();
    } else {
      toast.error("Failed to update customer");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  return (
    <>

    <div className="fixed inset-0 z-[70] bg-black/40 flex items-center justify-center montserrat-font-1">
      <div className="bg-white w-[820px] rounded-xl flex overflow-hidden shadow-2xl montserrat-font-1">
        {/* LEFT — Form */}
        <div className="flex-1 p-8 montserrat-font-1">
          <h2 className="text-xl font-bold text-center mb-6">
            Edit Customer Details
          </h2>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Name
            </label>
            <input
              type="text"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              className="w-full border border-blue-400 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-300 transition"
              placeholder="Customer Name"
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Billing Name
            </label>
            <input
              type="text"
              value={billingName}
              onChange={(e) => setBillingName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-200 transition"
              placeholder="Billing Name (Optional)"
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Billing GST
            </label>
            <input
              type="text"
              value={billingGst}
              onChange={(e) => setBillingGst(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-200 transition"
              placeholder="Billing GST (Optional)"
            />
          </div>

          <div className="mb-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Billing Address
            </label>
            <textarea
              value={billingAddress}
              onChange={(e) => setBillingAddress(e.target.value)}
              rows={4}
              className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-blue-200 transition resize-none"
              placeholder="Full Address"
            />
          </div>
        </div>

        {/* RIGHT — Actions */}
        <div className="w-56 montserrat-font-1 bg-gray-50 flex flex-col justify-center gap-4 p-6 border-l border-dashed border-gray-300">
          <button
            onClick={handleSave}
            className="bg-white border border-gray-300 hover:bg-gray-100 active:scale-95 transition-all py-5 rounded-xl font-bold text-gray-800 shadow-sm tracking-wide"
          >
            SAVE
          </button>
          <button
            onClick={onCloseAll}
            className="bg-white border border-gray-300 hover:bg-gray-100 active:scale-95 transition-all py-5 rounded-xl font-bold text-gray-800 shadow-sm tracking-wide"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
